import axios from 'axios';

const receipts = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/receipts`,
});

export default receipts;
